import { render, staticRenderFns } from "./ScheduleNotifications.vue?vue&type=template&id=244f5dea&scoped=true"
import script from "./ScheduleNotifications.vue?vue&type=script&lang=js"
export * from "./ScheduleNotifications.vue?vue&type=script&lang=js"
import style0 from "./ScheduleNotifications.vue?vue&type=style&index=0&id=244f5dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244f5dea",
  null
  
)

export default component.exports